import { render } from "./ChangeRequestBanner.vue?vue&type=template&id=25db7b65&scoped=true"
import script from "./ChangeRequestBanner.vue?vue&type=script&lang=js"
export * from "./ChangeRequestBanner.vue?vue&type=script&lang=js"

import "./ChangeRequestBanner.vue?vue&type=style&index=0&id=25db7b65&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25db7b65"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QCard,QCardSection,QList,QItem,QItemSection,QIcon,QCardActions});
